import { render, staticRenderFns } from "./SaleList.vue?vue&type=template&id=20a05461&scoped=true&"
import script from "./SaleList.vue?vue&type=script&lang=js&"
export * from "./SaleList.vue?vue&type=script&lang=js&"
import style0 from "./SaleList.vue?vue&type=style&index=0&id=20a05461&lang=scss&scoped=true&"
import style1 from "./SaleList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a05461",
  null
  
)

export default component.exports